import * as React from 'react';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { Input } from 'ui/shared/Input';
import { FadeCollapse } from 'ui/transitions/FadeCollapse';

export type OwnProps = {
    method: 'file' | 'email';
    type: string;
    textKey: string;
    csvDelim: string;
    fileTypes: { [type: string]: boolean };
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    onCSVChange: React.ChangeEventHandler<HTMLInputElement>;
    onCSVBlur: React.FocusEventHandler<HTMLInputElement>;
};

const RawDistributionOption = ({ method, type, textKey, fileTypes, csvDelim, onChange, onCSVChange, onCSVBlur, t }: OwnProps & TranslateProps) =>
    <div>
        <label>
            <input
                type="checkbox"
                id={ `edit-report-${method}-distribution-${type.toLowerCase()}` }
                data-type={ type }
                checked={ !!fileTypes[type] }
                onChange={ onChange }
            />
            { t(textKey) }
        </label>
        <FadeCollapse
            visible={ type === 'CSV' && !!fileTypes[type] }
            duration={ 200 }
            height="4em"
        >
            <div>
            <label htmlFor="edit-csv-delim">
                    { t('WC_CSV_DELIM') }
                </label>
            </div>
            <Input
                value={ csvDelim }
                maxLength={ 1 }
                id="edit-csv-delim"
                width="2em"
                onChange={ onCSVChange }
                onBlur={ onCSVBlur }
            />
                
            <div style={ { marginLeft: '20px' } }/>
            
        </FadeCollapse>
    </div>
;

export const DistributionOption = compose<OwnProps & TranslateProps, OwnProps>(
    translate(),
)(RawDistributionOption);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/distribution/DistributionOption.tsx